import { createAsyncThunk } from '@reduxjs/toolkit';
import jobApi from '~/apis/job';
import { CREATE_JOB, GET_BOARD_COUNT, GET_JOBS, MOVE_STAGE, UPDATE_JOB, GET_PHOTO, UPLOAD_PHOTO, DELETE_PHOTO, GET_PHOTO_DETAIL, EDIT_PHOTO, DELETE_JOB, ADD_ESTIMATE, GET_ESTIMATE, GET_ESTIMATE_DETAIL, UPLOAD_ESTIMATE, DELETE_ESTIMATE } from '~/utils/constants/actionType';
import { IParamsGetJobs, IPayloadAddJob, IPayloadUpdateJob, IResponseGetBoardCount, IResponseGetJobs, IJobUploadFile, IParamsGetJobPhotos } from '~/utils/interface/job';

export const handleGetJobs = createAsyncThunk<IResponseGetJobs, IParamsGetJobs>(
  GET_JOBS,
  async (params: IParamsGetJobs = {}, { rejectWithValue }) => {
    try {
      const res = await jobApi.getJobs(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetBoardCount = createAsyncThunk<IResponseGetBoardCount>(
  GET_BOARD_COUNT,
  async (_, { rejectWithValue }) => {
    try {
      const res = await jobApi.getBoardCount();
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleMoveStage = createAsyncThunk<any, { id: string; params: IParamsGetJobs }>(
  MOVE_STAGE,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      // Normalize "Waiting On Scope" to "Waiting on Scope" (API requires lowercase 'o')
      const normalizedParams = { ...params };
      if (normalizedParams.jobStage === "Waiting On Scope") {
        normalizedParams.jobStage = "Waiting on Scope";
      }
      
      const res = await jobApi.moveStage(id, normalizedParams);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateAddJob = createAsyncThunk<any, IPayloadAddJob>(
  CREATE_JOB,
  async (data: IPayloadAddJob, { rejectWithValue }) => {
    try {
      const res = await jobApi.addJob(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleDeleteJob = createAsyncThunk<any, string>(
  DELETE_JOB,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await jobApi.deleteJob(id);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateJob = createAsyncThunk<any, { id: string; data: IPayloadUpdateJob }>(
  UPDATE_JOB,
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await jobApi.updateJob(id, data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


export const handleGetPhoto = createAsyncThunk<any, { id: string; params:IParamsGetJobPhotos }>(
  GET_PHOTO,
  async ({ id, params }, { rejectWithValue }) => {
    try {

      const res = await jobApi.getPhotos(id, params);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetPhotoDetail = createAsyncThunk<any, { idJob: string; idPhoto:string }>(
  GET_PHOTO_DETAIL,
  async ({ idJob, idPhoto }, { rejectWithValue }) => {
    try {
      const res = await jobApi.getPhotoDetail(idJob, idPhoto);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);



export const handleUploadPhotos = createAsyncThunk<any, { id: string; param: IJobUploadFile }>(
  UPLOAD_PHOTO,
  async ({ id, param }, { rejectWithValue }) => {
    try {

      const res = await jobApi.uploadPhotos(id, param);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


export const handleUpdatePhoto = createAsyncThunk<any, { idJob: string; idPhoto:string; param: IJobUploadFile }>(
  EDIT_PHOTO,
  async ({ idJob, idPhoto, param }, { rejectWithValue }) => {
    try {

      const res = await jobApi.updatePhoto(idJob, idPhoto, param);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


export const handleDeletePhoto = createAsyncThunk<any, {idJob:string, idPhoto:string }>(
  DELETE_PHOTO,
  async ({ idJob, idPhoto }, { rejectWithValue }) => {
    try {

      const res = await jobApi.deletePhoto(idJob, idPhoto);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


//estimate
export const handleCreateEstimate = createAsyncThunk<any, {data:any }>(
  ADD_ESTIMATE,
  async ({ data }, { rejectWithValue }) => {
    try {

      const res = await jobApi.addEstimate(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetAllEstimate = createAsyncThunk<any, {filter:any}>(
  GET_ESTIMATE,
  async ({filter}, { rejectWithValue }) => {
    try {

      const res = await jobApi.getAllEstimate(filter);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetAllEstimateDetail = createAsyncThunk<any, {id:string}>(
  GET_ESTIMATE_DETAIL,
  async ({id}, { rejectWithValue }) => {
    try {

      const res = await jobApi.handleGetAllEstimateDetail(id);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateEstimate = createAsyncThunk<any, {id:string, data:any }>(
  UPLOAD_ESTIMATE,
  async ({id, data }, { rejectWithValue }) => {
    try {
      const res = await jobApi.updateEstimate(id, data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleDeleteEstimate = createAsyncThunk<any, {id:any}>(
  DELETE_ESTIMATE,
  async ({id }, { rejectWithValue }) => {
    try {
      const res = await jobApi.handleDeleteEstimate(id);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

